import { Loader2 } from "lucide-react";
import { Navigate } from "react-router";

import { useMe } from "@/lib/api";

export function HomePage() {
  const { data: me, isLoading } = useMe();
  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="text-muted h-6 w-6 animate-spin" />
      </div>
    );
  }
  if (me?.role === "facilitator" || me?.role === "admin") {
    return <Navigate to="/facilitator" replace />;
  }
  return <Navigate to="/program" replace />;
}
